import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button
        type="button"
        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
        aria-label="English"
      >
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="18" rx="2" fill="#B22234"/>
          <rect width="24" height="1.384" fill="white"/>
          <rect y="2.769" width="24" height="1.384" fill="white"/>
          <rect y="5.538" width="24" height="1.384" fill="white"/>
          <rect y="8.307" width="24" height="1.384" fill="white"/>
          <rect y="11.076" width="24" height="1.384" fill="white"/>
          <rect y="13.845" width="24" height="1.384" fill="white"/>
          <rect y="15.615" width="24" height="2.385" fill="#B22234"/>
          <rect width="9.692" height="9.692" fill="#3C3B6E"/>
          <g fill="white">
            <path d="M1.2 1.2h.6v.6h-.6z"/>
            <path d="M2.4 1.2h.6v.6h-.6z"/>
            <path d="M3.6 1.2h.6v.6h-.6z"/>
            <path d="M4.8 1.2h.6v.6h-.6z"/>
            <path d="M6 1.2h.6v.6h-.6z"/>
            <path d="M7.2 1.2h.6v.6h-.6z"/>
            <path d="M8.4 1.2h.6v.6h-.6z"/>
            <path d="M1.2 2.4h.6v.6h-.6z"/>
            <path d="M2.4 2.4h.6v.6h-.6z"/>
            <path d="M3.6 2.4h.6v.6h-.6z"/>
            <path d="M4.8 2.4h.6v.6h-.6z"/>
            <path d="M6 2.4h.6v.6h-.6z"/>
            <path d="M7.2 2.4h.6v.6h-.6z"/>
            <path d="M8.4 2.4h.6v.6h-.6z"/>
            <path d="M1.2 3.6h.6v.6h-.6z"/>
            <path d="M2.4 3.6h.6v.6h-.6z"/>
            <path d="M3.6 3.6h.6v.6h-.6z"/>
            <path d="M4.8 3.6h.6v.6h-.6z"/>
            <path d="M6 3.6h.6v.6h-.6z"/>
            <path d="M7.2 3.6h.6v.6h-.6z"/>
            <path d="M8.4 3.6h.6v.6h-.6z"/>
          </g>
        </svg>
      </button>
      <button
        type="button"
        className={`lang-btn ${i18n.language === 'ka' ? 'active' : ''}`}
        onClick={() => changeLanguage('ka')}
        title="ქართული"
        aria-label="ქართული"
      >
        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="16" fill="white"/>
          {/* Main cross */}
          <rect x="10" y="0" width="4" height="16" fill="#D00000"/>
          <rect x="0" y="6" width="24" height="4" fill="#D00000"/>
          {/* Small crosses in corners */}
          <rect x="2" y="2" width="2" height="2" fill="#D00000"/>
          <rect x="20" y="2" width="2" height="2" fill="#D00000"/>
          <rect x="2" y="12" width="2" height="2" fill="#D00000"/>
          <rect x="20" y="12" width="2" height="2" fill="#D00000"/>
        </svg>
      </button>
    </div>
  );
};

export default LanguageSwitcher;

